// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3N0tO","col":"styles_col__2P_eY"};